import {
  GET_EXPENSES_TYPES,
  CREATE_EXPENSES_TYPE,
  REMOVE_EXPENSES_TYPE,
  UPDATE_EXPENSES_TYPE,
} from './types';

export const getExpensesTypes = (companyId) => ({
  type: GET_EXPENSES_TYPES,
  request: {
    method: 'GET',
    url: `/company/${companyId}/expense-types`,
  },
  meta: {
    thunk: true,
  },
});

export const createExpensesType = (companyId, payload) => ({
  type: CREATE_EXPENSES_TYPE,
  request: {
    method: 'POST',
    url: `/company/${companyId}/expense-types`,
    data: payload,
  },
  meta: {
    thunk: true,
  },
});

export const removeExpensesType = (companyId, expenseTypeId) => ({
  type: REMOVE_EXPENSES_TYPE,
  expenseTypeId,
  request: {
    method: 'DELETE',
    url: `/company/${companyId}/expense-types/${expenseTypeId}`,
  },
  meta: {
    thunk: true,
  },
});

export const updateExpenseType = (companyId, expenseTypeId, payload) => ({
  type: UPDATE_EXPENSES_TYPE,
  expenseTypeId,
  request: {
    method: 'PATCH',
    url: `/company/${companyId}/expense-types/${expenseTypeId}`,
    data: payload,
  },
  meta: {
    thunk: true,
  },
});
